module.exports = __webpack_public_path__ + "img/miniapp.e2757f57.svg";